import React from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

interface GSAPContextValue {
  tl: gsap.core.Timeline | null
}

const GSAPContext = React.createContext<GSAPContextValue>({ tl: null })

export function GSAPProvider({ children }: { children: React.ReactNode }) {
  return (
    <GSAPContext.Provider value={{ tl: null }}>
      {children}
    </GSAPContext.Provider>
  )
}

export default function useGSAP() {
  return React.useContext(GSAPContext)
}